import React from 'react';

const styles = {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh', // Full screen height
      fontSize: '1.5rem',
      color: '#555',
    },
  };
  
const Loading = () => {
  return (
    <div style={styles.container}>
      {/* You can add a spinner or skeleton here */}
      <p>Loading...</p>
    </div>
  );
};



export default Loading;
